<template>
  <div class="login-container">
    <div class="row p-sm bg-color-login">
      <div class="col-md-12">
        <div class="text-center">
          <h4>ログイン</h4>
        </div>
        <div class="alert alert-danger" v-if="err">
          <span id="message" v-html="err"></span>
        </div>
        <div class="hpanel">
          <form @submit.prevent="doLogin">
            <div class="panel-body">
              <div class="form-group">
                <label class="control-label label-normal" for="email">メールアドレス</label>
                <input type="text" name="email" id="email" class="form-control" v-model="email" v-validate="'required|email|max:150'" data-vv-as="メールアドレス">
                <span style="display: block" v-show="errors.has('email')" class="text-danger">※{{ errors.first('email') }}</span>
              </div>
              <div class="form-group">
                <label class="control-label label-normal" for="password">パスワード</label>
                <input type="password" name="password" id="password" class="form-control" v-model="password" v-validate="'required|max:64'" data-vv-as="パスワード">
                <span style="display: block" v-show="errors.has('password')" class="text-danger">※{{ errors.first('password') }}</span>
              </div>
              <button id="login" class="btn btn-warning btn-block" type="submit">ログイン</button>
              <div class="form-group text-center mr-t-15">
                <p>※ パスワードをお忘れの場合は、<router-link class="text--underline" :to="{path: 'reset-password'}">こちら</router-link></p>
              </div>
              <div id="box-btn-register-link" class="form-group">
                <button type="button" class="btn btn-info btn-block" @click.prevent="toSignup">新規登録</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/services/authenticationservice'
import store from '@/store'
import msg from '@/common/msg'
import Util from '@/common/utility'
import * as code from '@/common/code'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      email: null,
      password: null,
      showError: false,
      err: null,
      loader: null
    }
  },
  async created () {
    if (this.$route.query.token) {
      try {
        localStorage.setItem('tokenSalmon', this.$route.query.token)
        await Util.getSellerInfo()
        store.commit('setStatus', '1')
        store.commit('doAuthenticated', true)
        this.$router.push(this.$route.query.redirect || '/home')
      } catch (e) {
        store.dispatch('doLogout')
      }
    }
    if (store.getters.getResultCode) {
      if (store.getters.getResultCode === code.exceptCountry) {
        this.err = msg.exceptCountry
      } else {
        this.err = msg.signupErr
      }
    }
  },
  methods: {
    async doLogin () {
      let logParams = {
        name: eventCode.click_login_button,
        properties: {
          email: this.email
        }
      }
      EventService.postTrackLog(logParams)
      const self = this
      let validated = await this.$validator.validateAll()
      if (validated) {
        self.loader = this.$loading.show()
        AuthenticationService.login(this.email, this.password)
          .then(async (resp) => {
            store.commit('setStatus', resp.TSAgreementFlg)
            localStorage.setItem('tokenSalmon', resp.loginResponse.accessToken)
            localStorage.setItem('isShowModalAmazonExpiration', 1)
            store.commit('doAuthenticated', true)
            if (resp.TSAgreementFlg === '0') {
              this.$router.push('/termsofservice')
            } else {
              await Util.getSellerInfo()
              this.$router.push(this.$route.query.redirect || '/home')
            }
            let storageSkipShowRegisterInfoName = `${store.getters.getUser.sellerId}-SkipShowRegisterInfo`
            localStorage.setItem(storageSkipShowRegisterInfoName, false)
          })
          .catch(error => {
            if (error !== msg.serverErr && typeof error !== 'object') {
              this.err = error
            }
          })
          .finally(() => {
            self.loader.hide()
          })
      }
    },
    toSignup () {
      this.$router.push('/signup')
    }
  },
  mounted () {
    $('.vld-overlay').remove()
    setTimeout(() => {
      $('chat').hide()
    }, 1200)
  },
  beforeDestroy () {
    store.commit('saveResultCode', null)
    self.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/Login.vue